var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { LoaderService } from './loader.service';
import * as $ from 'jquery';
var AppUtil = /** @class */ (function () {
    function AppUtil(spinner) {
        this.spinner = spinner;
        this.loaderCount = 0;
        this.status = 0;
    }
    // sort(field, sortArr, model, desc) {
    //   const hasValue = sortArr[field].value;
    //   const sortBy = sortArr[field].sortBy;
    //   // model= (typeof(model))!==number ? model : getStatus(model)
    //   return model.sort((a, b) => {
    //     const nameA = (hasValue) ? hasValue(a[field]) : a[field];
    //     const nameB = (hasValue) ? hasValue(b[field]) : b[field];
    //     return (sortBy === 'number') ? sortNumber(nameA, nameB) :
    //       ((sortBy === 'boolean') ? sortboolean(nameA, nameB) : sortString(nameA, nameB));
    //   });
    AppUtil.prototype.sort = function (field, sortArr, model, desc) {
        var hasValue = sortArr[field] ? sortArr[field].value : '';
        var sortBy = sortArr[field] ? sortArr[field].sortBy : '';
        // model= (typeof(model))!==number ? model : getStatus(model)
        return model.sort(function (a, b) {
            var fieldExistA;
            fieldExistA = a ? a[field] : '';
            var fieldExistB;
            fieldExistB = b ? b[field] : '';
            var nameA = (hasValue) ? hasValue(fieldExistA) : fieldExistA;
            var nameB = (hasValue) ? hasValue(fieldExistB) : fieldExistB;
            return (sortBy === 'number') ? sortNumber(nameA, nameB) :
                ((sortBy === 'boolean') ? sortboolean(nameA, nameB) : sortString(nameA, nameB));
        });
        function sortboolean(a, b) {
            if (a === true) {
                return -1;
            }
            else if (b === false) {
                return 1;
            }
            //  return (a) ? -1 : 1;
            // return (a === b) ? 0 : a ? -1 : 1;
        }
        function sortString(a, b) {
            a = a ? a.toLowerCase() : null;
            b = b ? b.toLowerCase() : null;
            // console.log(a, b);
            if (a === null) {
                return 1;
            }
            else if (b === null) {
                return -1;
            }
            else if (a > b) {
                return (desc) ? -1 : 1;
            }
            else if (a < b) {
                return (desc) ? 1 : -1;
            }
            else {
                return 0;
            }
        }
        function sortNumber(a, b) {
            // console.log(a, b);
            if (a > b) {
                return (desc) ? -1 : 1;
            }
            else if (a < b) {
                return (desc) ? 1 : -1;
            }
            else {
                return 0;
            }
        }
    };
    AppUtil.prototype.spinnerInit = function () {
        this.loaderCount++;
        // console.log('spinner init', this.loaderCount);
        if (!this.status) {
            this.spinner.displayLoader(true);
        }
        this.status = 1;
    };
    AppUtil.prototype.spinnerDone = function () {
        this.loaderCount--;
        // console.log('spinner done', this.loaderCount);
        if (this.loaderCount <= 0 && this.status) {
            this.spinner.displayLoader(false);
            this.status = 0;
        }
    };
    AppUtil.prototype.spinnerReset = function () {
        this.loaderCount = 0;
    };
    AppUtil.prototype.setAppFavicon = function (id, icon) {
        $('#' + id).attr('href', icon);
    };
    AppUtil = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [LoaderService])
    ], AppUtil);
    return AppUtil;
}());
export { AppUtil };



//////////////////
// WEBPACK FOOTER
// ./src/app/app.service.ts
// module id = ./src/app/app.service.ts
// module chunks = main